import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GeocodedPlace } from '../../domain/models/geocoded-place.model';
import { IGeocodingRepository } from '../../domain/repositories/geocoding.repository';
import { NominatimRemoteDatasource } from '../datasources/remote/nominatim.remote-datasource';
import { GeocodedPlaceMapper } from '../mappers/geocoded-place.mapper';

@Injectable()
export class GeocodingRepositoryImpl implements IGeocodingRepository {
  private readonly datasource = inject(NominatimRemoteDatasource);
  private readonly mapper = inject(GeocodedPlaceMapper);

  public search(query: string): Observable<readonly GeocodedPlace[]> {
    return this.datasource.search(query).pipe(
      map((dtos) => this.mapper.toDomainList(dtos)),
    );
  }

  public reverse(latitude: number, longitude: number): Observable<GeocodedPlace | null> {
    return this.datasource.reverse(latitude, longitude).pipe(
      map((dto) => this.mapper.toDomainList([dto])[0] ?? null),
    );
  }
}
